import React, { useContext } from "react";
import { Layout, Menu } from "antd";
import Logo from "../../assets/img/logo.png";
import { Link, useHistory } from "react-router-dom";
import { NavContext } from "../../state/NavContext";
import { UserContext } from "../../state/UserContext";
import SubMenu from "antd/lib/menu/SubMenu";
import { SideContext } from "../../state/SideContext";

const { Header } = Layout;

const Navbar = () => {
  const history = useHistory();
  const { activeIndex } = useContext(NavContext);
  const { setSideIndex } = useContext(SideContext);
  const { user, setUser } = useContext(UserContext);

  const handleLogout = () => {
    setUser(null);
    setSideIndex("dashboard");
    localStorage.removeItem("user");
    localStorage.clear();
    history.push("/login");
  };

  return (
    <Header
      style={{
        position: "fixed",
        zIndex: 1,
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <img className="logo" src={Logo} alt="Movie Game Pedia" />
      <Menu
        inlineCollapsed={false}
        multiple={false}
        theme="dark"
        mode="horizontal"
        defaultSelectedKeys={["home"]}
        selectedKeys={`${activeIndex}`}
      >
        <Menu.Item key="home">
          <Link to="/">Home</Link>
        </Menu.Item>
        <Menu.Item key="movies">
          <Link to="/movies">Movies</Link>
        </Menu.Item>
        <Menu.Item key="games">
          <Link to="/games">Games</Link>
        </Menu.Item>
        {user ? (
          <>
            <SubMenu key="admin" title="Admin Panel">
              <Menu.Item key="dashboard">
                <Link to="/admin/dashboard">Dashboard</Link>
              </Menu.Item>
              <Menu.Item key="logout">
                <div onClick={handleLogout}>Logout</div>
              </Menu.Item>
            </SubMenu>
          </>
        ) : (
          <Menu.Item key="login">
            <Link to="/login">Login</Link>
          </Menu.Item>
        )}
      </Menu>
    </Header>
  );
};

export default Navbar;
